import { BradenScaleScreen } from "app/screens/residents/show/BradenScaleScreen";

export default function BradenScalePage() {
  return <BradenScaleScreen />;
}
